module.exports = __webpack_public_path__ + "static/pricing-desktop-737c67d2ef95bffcc8c52a1a359c7cac.png";